import React from "react";
import { observer } from "mobx-react-lite";
import { Typography, Button, ButtonMenu, Scrollbar } from "@ann/web-components";
import {
  GranteesListContainerExternal,
  GranteesListContainerInternal,
  GranteeItem,
  GranteeInfo,
  GranteeActions,
  TitleDescriptionContainer,
  TitleAndListContainer,
} from "./Modal.styled";
import { NameInitialsAvatar } from "react-name-initials-avatar";

const PendingGranteesList = observer(
  ({
    pendingGrantees,
    currentSelectionType,
    privileges,
    onUpdatePermission,
    onRemove,
  }) => {
    if (pendingGrantees.length === 0) return null;

    return (
      <TitleAndListContainer>
        <TitleDescriptionContainer>
          <Typography
            category="subtitle"
            size="small"
            weight="bold"
            color="subtitle"
          >
            To be added
          </Typography>
          <Typography
            category="body"
            size="medium"
            weight="regular"
            color="body"
          >
            You're about to add {pendingGrantees.length} users
          </Typography>
        </TitleDescriptionContainer>

        <GranteesListContainerExternal>
          <Scrollbar size="small">
            <GranteesListContainerInternal>
              {pendingGrantees.map((grantee) => (
                <GranteeItem key={grantee.grantee_uuid}>
                  <GranteeInfo>
                    <NameInitialsAvatar
                      name={grantee.grantee_name}
                      bgColor="#2563eb"
                      textColor="#ffffff"
                      size="24px"
                      borderRadius="50%"
                      textWeight="bold"
                      textSize="18px"
                      borderColor="#ffffff"
                      borderStyle="solid"
                      borderWidth="2px"
                    />
                    <Typography
                      category="body"
                      size="medium"
                      weight="regular"
                      color="body"
                    >
                      {grantee.grantee_name} {grantee.grantee_email}
                    </Typography>
                  </GranteeInfo>

                  <GranteeActions>
                    <ButtonMenu
                      iconPosition="right"
                      label={
                        grantee.privileges[0]?.privilege_name || "Permission"
                      }
                      menuPosition="bottom"
                      onChange={(value) =>
                        onUpdatePermission(grantee.grantee_uuid, value)
                      }
                      size="medium"
                      pill={true}
                      type="secondary"
                      width="auto"
                      usePortal={true}
                      disableEffects={true}
                    >
                      <ButtonMenu.Menu>
                        {privileges[
                          currentSelectionType === "folder"
                            ? "folderPrivileges"
                            : "documentPrivileges"
                        ].map((privilege) => (
                          <ButtonMenu.Item
                            key={privilege.entityPrivilegeUuid}
                            label={privilege.privilegeName}
                            value={privilege.privilegeName}
                          >
                            {privilege.privilegeName}
                          </ButtonMenu.Item>
                        )) || []}
                      </ButtonMenu.Menu>
                    </ButtonMenu>
                    <Button
                      icon="close"
                      size="medium"
                      type="tertiary"
                      onClick={() => onRemove(grantee.grantee_uuid)}
                    />
                  </GranteeActions>
                </GranteeItem>
              ))}
            </GranteesListContainerInternal>
          </Scrollbar>
        </GranteesListContainerExternal>
      </TitleAndListContainer>
    );
  }
);

export default PendingGranteesList;
